var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29297 10.353V20.706H5.17532V10.353H1.29297ZM3.8812 19.4118H2.55991V16.7964H3.8812V19.4118ZM3.90838 15.5295H2.5612V12.9141H3.90838V15.5295Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9393 6.47059V3.88235H11.6452V0H10.3511V3.88235H9.05699V6.47059H6.46875V20.7059H15.5276V6.47059H12.9393ZM9.05699 19.4118H7.76287V16.8235H9.05699V19.4118ZM9.05699 15.5838H7.76287V12.9412H9.05699V15.5838ZM9.05699 11.7014H7.76287V9.05882H9.05699V11.7014ZM11.6452 19.4118H10.3511V16.8235H11.6452V19.4118ZM11.6452 15.5838H10.3511V12.9412H11.6452V15.5838ZM11.6452 11.7014H10.3511V9.05882H11.6452V11.7014ZM14.2335 19.4118H12.9393V16.8235H14.2335V19.4118ZM14.2335 15.5838H12.9393V12.9412H14.2335V15.5838ZM14.2335 11.7014H12.9393V9.05882H14.2335V11.7014Z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8242 9.05859V20.7057H22.0007V14.2351L16.8242 9.05859ZM19.4526 19.4918H18.1183V18.076H19.4526V19.4918ZM19.4526 16.9035H18.1183V15.4878H19.4526V16.9035ZM19.4526 14.3153H18.1183V12.8995H19.4526V14.3153Z",
    fill: "#828282"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20.7059,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.36dcfd62b2e0229fc36ef15d8be74d33.svg";
export { ForwardRef as ReactComponent };